export const hasMoreThan1Element = (array: Array<any>) => hasMoreThenNElements(array, 1)

export const hasMoreThenNElements = (array: Array<any> = [], n: number) => array.length > n
